import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import type { HypersceneAdvancedDemo } from '../../hyperscene-advanced.component';

/**
 * The debug indicator of running requests over the viewer. The page owns the state; this component only renders it, so
 * it is checked with the page.
 */
@Component({
  selector: 'div[viewer-loading-overlay]',
  templateUrl: './viewer-loading-overlay.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class ViewerLoadingOverlayComponent {
  @Input({ required: true }) public viewer!: HypersceneAdvancedDemo;
}
